/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import Card from './card'
import Container from './container'
// Images
import UnitedStates from '../images/flags/united_states.webp'
import Canada from '../images/flags/canada.webp'
import Poland from '../images/flags/poland.webp'
import Germany from '../images/flags/germany.webp'
import UnitedKingdom from '../images/flags/united_kingdom.webp'
import France from '../images/flags/france.webp'

const Location = () => {
    return (
        <section className="locations bg-map py-48">
            <Container>
                <div className="header text-center mb-16">
                    <h1 className="text-lg text-purple-500 font-semibold uppercase mb-1">Locations</h1>
                    <h2 className="text-3xl text-gray-200 font-bold">Choose your Location.</h2>
                </div>
                <div className="body">
                    <div className="grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 sm:gap-6 md:gap-10 lg:gap-10">
                        <div>
                            <Card>
                                <div className="location flex items-center">
                                    <img src={UnitedStates} className="w-10 h-6 rounded-sm select-none" alt='UnitedStates' />
                                    <h1 className="ml-4 text-gray-100 font-medium">Vint Hill, Virginia</h1>
                                </div>
                            </Card>
                        </div>
                        <div className="mt-0 sm:mt-0 md:mt-6 lg:mt-6">
                            <Card>
                                <div className="location flex items-center">
                                    <img src={France} className="w-10 h-6 rounded-sm select-none" alt='France' />
                                    <h1 className="ml-4 text-gray-100 font-medium">Gravelines, France</h1>
                                </div>
                            </Card>
                        </div>
                        <div>
                            <Card>
                                <div className="location flex items-center">
                                    <img src={UnitedStates} className="w-10 h-6 rounded-sm select-none" alt='UnitedStates' />
                                    <h1 className="ml-4 text-gray-100 font-medium">Chicago, Illinois</h1>
                                </div>
                            </Card>
                        </div>
                        <div>
                            <Card>
                                <div className="location flex items-center">
                                    <img src={UnitedStates} className="w-10 h-6 rounded-sm select-none" alt='UnitedStates' />
                                    <h1 className="ml-4 text-gray-100 font-medium">Phoenix, Arizona</h1>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default Location
